import { Box, Typography } from '@mui/material';
import React from 'react';
import Patientdetailsdata from './Patientdetailsdata';
import GraphReadings from './GraphReadings';

const ReadingsBox = ({ probabilityValue }) => {
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px',
            // width: '377px',
            justifyContent: 'space-between',
            marginLeft: '24px',
          }}
        >
          <GraphReadings header={'Baseline'} colour={'#DEB56B'} />
          <GraphReadings header={'Previous Reading'} colour={'#91B4A5'} />
          <GraphReadings header={'KardiaAlert-Flagged EKG'} colour={'#885FA5'} />
        </Box>

        <Patientdetailsdata
          labledata="* Predicted probability of ST depression/T wave inversion :"
          keydata={`${probabilityValue}%`}
          sx={{ paddingBottom: 0, fontSize: '15px', fontFamily: 'Work Sans' }}
        />
      </Box>
    </>
  );
};

export default ReadingsBox;
